module.exports = "<div class=\"example-pizza-party\">\n    {{data}}\n</div>\n<a class=\"dismiss\" (click)=\"dismiss()\" >\n  {{'Dismiss' | translate}}\n</a>\n"